import MenuIcon from '@mui/icons-material/Menu';
import DownloadIcon from '@mui/icons-material/Download';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { Tooltip } from '@mui/material';
import { DataGrid, GridRenderCellParams, ukUA } from '@mui/x-data-grid';
import * as React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { SeriesInfoModal } from './SeriesInfoModal';
import useModal from '../../../shared/hooks/useModal/useModal';
import {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getExcelFileSeriesRequest,
  getShortExcelFileSeriesRequest,
} from 'modules/EventsLog/SeriesReport/services/actions';
import styles from './SeriesInfoModal.module.scss';
import { style } from '../../../common/DataTable/style';

interface Props {
  data: any;
  dateParams: any;
  isFileDownloading: boolean;
}

export const SeriesTable: React.FC<Props> = ({ data, dateParams, isFileDownloading }) => {
  const { isShow, openModal, closeModal } = useModal();
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = React.useState(15);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [lockedRow, setLockedRow] = useState<string | null>(null);

  return (
    <div style={{ height: 599, width: '100%', marginTop: '19px' }}>
      <DataGrid
        localeText={ukUA.components.MuiDataGrid.defaultProps.localeText}
        rows={data}
        headerHeight={34}
        rowHeight={34}
        columns={[
          { field: 'series', headerName: 'Серія', width: 140 },
          {
            field: 'gtin',
            headerName: 'Код GTIN',
            width: 145,
          },
          { field: 'countryCode', headerName: 'Країна', width: 85 },
          { field: 'productInternalName', headerName: 'Внутрішня назва продукту', minWidth: 330, flex: 1 },
          { field: 'quantityToPrint', headerName: 'Кількість по рецептам, од.', width: 190 },
          { field: 'ongoingRecipesCount', headerName: 'Активних рецептів', width: 130 },
          { field: 'finishedRecipesCount', headerName: 'Завершених рецептів', width: 130 },
          { field: 'ongoingPrintJobsCount', headerName: 'Активних завдань на друк', width: 130 },
          { field: 'finishedPrintJobsCount', headerName: 'Завершених завдань на друк', width: 130 },
          { field: 'canceledPrintJobsCount', headerName: 'Скасованих завдань на друк', width: 130 },
          {
            field: 'button',
            headerName: 'Меню',
            headerAlign: 'center',
            width: 70,
            align: 'center',
            renderCell: (params: GridRenderCellParams<Date>) => (
              <>
                <Tooltip title="Скачати як звіт в Excel" placement="top">
                  <a
                    style={{
                      pointerEvents: lockedRow === params.row.id || isFileDownloading ? 'none' : 'auto',
                      opacity: lockedRow === params.row.id || isFileDownloading ? 0.5 : 1,
                      cursor: 'pointer',
                    }}
                    aria-disabled={isFileDownloading}
                    onClick={() => {
                      if (lockedRow === params.row.id || isFileDownloading) return;

                      setSelectedRow(params.row);
                      setLockedRow(params.row.id);

                      dispatch(
                        getShortExcelFileSeriesRequest({
                          series: params.row.series,
                          gtin: params.row.gtin,
                          countryCode: params.row.countryCode,
                        }),
                      );

                      setTimeout(() => {
                        setLockedRow(null);
                      }, 20000);
                    }}
                  >
                    {isFileDownloading ? (
                      <HourglassEmptyIcon className={styles.icon} />
                    ) : (
                      <DownloadIcon className={styles.icon} />
                    )}
                  </a>
                </Tooltip>
                <Tooltip title="Детально" placement="top">
                  <MenuIcon
                    className={styles.icon}
                    onClick={() => {
                      setSelectedRow(params.row);
                      openModal();
                    }}
                  />
                </Tooltip>
              </>
            ),
          },
        ]}
        disableSelectionOnClick
        disableColumnMenu
        disableColumnSelector
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        pagination
        sx={style}
        componentsProps={{
          pagination: {
            SelectProps: {
              MenuProps: {
                sx: {
                  '& .MuiMenuItem-root': {
                    fontSize: 14,
                    bgcolor: '#ffffff',
                  },
                },
                PaperProps: {
                  sx: {
                    bgcolor: '#ffffff',
                  },
                },
              },
            },
          },
        }}
      />

      {isShow && (
        <SeriesInfoModal
          isShown={isShow}
          dateParams={dateParams}
          series={selectedRow}
          closeModal={closeModal}
          seriesDetailedParams={{
            series: selectedRow.series,
            gtin: selectedRow.gtin,
            countryCode: selectedRow.countryCode,
          }}
        />
      )}
    </div>
  );
};
